import { isRequiredCurrency } from 'utils/validators';
import moment from 'moment-timezone';

const validate = values => {
  const errors = {};

  if (values.hourlyList && values.hourlyList.length) {
    const hourlyList = values.hourlyList;
    const hourlyListErrors = [];
    
    hourlyList.forEach((item, index) => {
      let errorMessage = null;
      
      
      if (isRequiredCurrency(item)) {
        errorMessage = 'Value for at least one currency should be filled in';
      }
      

      if (item?.isMaster !== true && !item?.startTime) {
        errorMessage = 'Start time is required';
      }
      
      if (item?.isMaster === true) {
        const minHours = parseInt(item.minHours);
        const maxHours = parseInt(item.maxHours);
        
        if (!item.minHours || minHours < 1 || minHours > 24) {
          errorMessage = 'Min hours must be between 1 and 24';
        } else if (!item.maxHours || maxHours < 1 || maxHours > 24) {
          errorMessage = 'Max hours must be between 1 and 24';
        } else if (minHours > maxHours) {
          errorMessage = 'Min hours cannot be greater than max hours';
        }
      }
      
      if (item?.isMaster !== true && item?.startTime && !errorMessage) {
        const currentTime = moment(item.startTime).format('HH:mm');
        const duplicates = hourlyList.filter(
          (entry, idx) => 
            idx !== index && 
            entry?.isMaster !== true && 
            entry?.startTime &&
            moment(entry.startTime).format('HH:mm') === currentTime
        );
        
        if (duplicates.length > 0) {
          errorMessage = 'Duplicate start time - each entry must have a unique time';
        }
      }
      
      if (errorMessage) {
        hourlyListErrors[index] = errorMessage;
      }
    });
    
    if (hourlyListErrors.length > 0) {
      errors.hourlyList = {
        ...hourlyListErrors,
        _error: {
          ...hourlyListErrors.map(err => err)
        }
      };
    }
  }

  return errors;
};

export default validate;